import { Component } from '@angular/core';


export class SkyKeyInfoValueComponent { static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-key-info-value',
  template: `<ng-content></ng-content>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
